import { BRAND, aboutCredentials, images, platformLogos } from '../data';

export default function About() {
  return (
    <section className="section about" id="about">
      <div className="container">
        <div className="about-layout" data-reveal>
          <div className="about-copy">
            <h2 className="display-2">
              You’re in <em>good hands.</em>
            </h2>
            <p className="lede">Accuracy matters when you’re responsible for someone else’s money.</p>
            <p>
              Before {BRAND}, founder Dinar Davis worked across finance and operations for
              organizations including 20th Century Fox and nonprofit organizations, managing work
              spanning production finance, financial controls, payroll, and day-to-day business
              operations.
            </p>
            <p>
              That experience shapes how we approach the books today: carefully, consistently, and
              with an understanding of the business behind the numbers.
            </p>
          </div>

          <figure className="portrait-frame">
            <img src={images.founder} alt={`Dinar Davis, founder of ${BRAND}`} />
          </figure>
        </div>

        <div className="credential-suite" data-reveal>
          <p className="credential-suite-label">Professional credentials &amp; platforms</p>
          <div className="credential-badges">
            {aboutCredentials.map((item) => (
              <div className="credential-badge" key={item.name}>
                <img className="credential-logo credential-logo-lg" src={item.src} alt={item.name} />
              </div>
            ))}
            <div className="credential-badge platform-badge">
              <span className="platform-logos">
                {platformLogos.map((platform) => (
                  <img
                    className="platform-logo"
                    key={platform.name}
                    src={platform.src}
                    alt={platform.name}
                  />
                ))}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
